module.exports = __webpack_public_path__ + "img/111-Bleu Acier.jpg";